/**
 * Intelligems A/B — Static rating in cart drawer footer (replaces payment icons)
 *
 * Intelligems inject (Group 1):
 *   document.body.setAttribute('data-ig-cart-trustpilot', 'true');
 */
(function () {
  'use strict';

  if (window.__igCartTrustpilotBooted) return;
  window.__igCartTrustpilotBooted = true;

  var ATTR = 'data-ig-cart-trustpilot';

  function isEnabled() {
    if (!document.body) return false;
    var value = String(document.body.getAttribute(ATTR) || '').trim().toLowerCase();
    return value === 'true' || value === '1' || value === 'on' || value === 'yes';
  }

  window.IgCartTrustpilot = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(ATTR, 'true');
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(ATTR, 'false');
    },
    isEnabled: isEnabled,
  };
})();
